import { useEffect } from "react";
import { useScrollReveal, useCountUp } from "@/hooks/useAnimations";

export const AnimatedCounter = ({ end, suffix = "", prefix = "" }) => {
  const [ref, isVisible] = useScrollReveal(0.5);
  const [count, startCounting] = useCountUp(end, 2000);

  useEffect(() => {
    if (isVisible) startCounting();
  }, [isVisible, startCounting]);

  return (
    <span ref={ref} className="number-counter">
      {prefix}{count}{suffix}
    </span>
  );
};
